import React, { useContext, useEffect, useState, useCallback } from 'react'
import moment from 'moment'
import { map, size } from 'lodash'
import { Context } from '../../../Store'
import { Grid } from '@material-ui/core'
import { FormDatePicker } from './FormDatePicker'
import { useTranslation } from 'react-i18next'
import { Alert } from '@material-ui/lab'
import { disableWeekends } from './LegacyValidations'
import { ErrorMessage } from './ErrorMessage'

export const CheckInDate = () => {
  const [state, dispatch] = useContext(Context)
  const [startDate, setStartDate] = useState(state?.start_date)
  const [showCheckInWarningMessage, setShowCheckInWarningMessage] = useState(false)
  const { t } = useTranslation()

  const { property } = state
  const { minStay = 1, notAvailablePeriods } = property

  const remappedNotAvailablePeriods = map(notAvailablePeriods, (period) => ({
    endDate: moment(period[1]),
    startDateWithMinStay: moment(period[0]).subtract(minStay, 'months'),
    startDate: moment(period[0]),
  }))

  const disableBookedDates = useCallback((date) => {
    let result = map(remappedNotAvailablePeriods, (booking) => {
      return date.isSameOrBefore(booking.endDate) && date.isSameOrAfter(booking.startDateWithMinStay)
    })
  
    if (size(result) === 0) {
      return false
    }
  
    return result.reduce((result, condition) => result || condition)
  }, [])

  const onChangeStartDate = (date) => {
    const momentStartDate = moment(date).toDate()
    dispatch({ type: 'SET_START_DATE', payload: momentStartDate })
    setStartDate(momentStartDate)
  }

  useEffect(() => {
    setShowCheckInWarningMessage(
      state.start_date && moment(state.start_date).isSameOrBefore(moment().add(20, 'days'))
    )
  }, [startDate])

  return (
    <>
      <Grid item xs={12} lg={11}>
        <FormDatePicker
          label={t('booking.checkIn.dateCheckIn.placeholder')}
          name="start_date"
          value={startDate}
          onChange={(props) => {onChangeStartDate(props.format('YYYY-MM-DD'))}}
          minDate={moment().add(20, 'days')}
          maxDate={moment().add(1, 'days').add(4, 'years')}
          shouldDisableDate={(date) => disableBookedDates(date) || disableWeekends(date)}
          error={state?.error?.start_date}
        />
        {state?.error?.start_date && <ErrorMessage error={state?.error?.start_date} />}
      </Grid>
      {showCheckInWarningMessage && (
        <Grid item xs={12} lg={11}>
          <Alert severity="warning">{t('booking.checkIn.warningMessage')}</Alert>
        </Grid>
      )}
    </>
  )
}